import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { JsonResult } from '../models/json-result';
import { MeterReadingInsertAuthorization } from '../models/meter-reading-insert-authorization';
import { MeterReadingDownloadPdf, MeterReadingInsert } from '../models/meter-reading-insert';
import { MeterReadingEmailRecibos } from '../models/meter-reading-email';
import { ParameterPrivacidadDatosSAPDTO, PoliticaParam, RowParam } from '../models/privacity-data-insert-v2';

import { HtmlPolicy } from '../models/html-policy';
import { MeterReadingInsertResponse } from '../models/meter-reading-insert-response';
import { NextMeterReadingNextDateResponse } from '../models/meter-reading-next-date-response';
import { DataPrivacy1LogInsertDTO } from '../models/privacity-data-insert'
import { LogPrivacyDataFilterByTypeDto } from '../models/privacity-data-listby-type'
import { PrivacyDataFilterModel } from '../models/privacity-data-filter'

@Injectable({
  providedIn: 'root'
})
export class VirtualOfficeService {
  virtualOfficeServiceUrl: string;
  private MeterReadingController: string = "MeterReading";
  constructor(private environmentService: EnvironmentService,
    private httpClient: HttpClient) {
    this.virtualOfficeServiceUrl = this.environmentService.virtualOfficeServiceUrl;
  }
  getMeterReadingInsertAuthorization(documentNumber: string, documentType: string, clientCode: string, captcha: string) {
    const url = `${this.virtualOfficeServiceUrl}MeterReading/Authorization`;
    let httpParams = {
      clientCode,
      documentType,
      documentNumber,
      captcha
    };
    return this.httpClient.post<JsonResult<MeterReadingInsertAuthorization>>(url, httpParams).toPromise();
  }
  getImageUrl(key: string) {
    let url = `${this.virtualOfficeServiceUrl}Master/Detail/${key}`;
    return this.httpClient.get<JsonResult<string>>(url).toPromise();
  }
  getHtmlPolicy(key: string) {
    let url = `${this.virtualOfficeServiceUrl}Master/HtmlPolicy/${key}`;
    return this.httpClient.get<JsonResult<HtmlPolicy>>(url).toPromise();
  }
  insertMeterReading(data: MeterReadingInsert) {
    const url = `${this.virtualOfficeServiceUrl}${this.MeterReadingController}/Add`;
    return this.httpClient.post<JsonResult<MeterReadingInsertResponse>>(url, data).toPromise();
  }

  getMeterReadingRegisterProof(data: MeterReadingDownloadPdf) {
    //comment
    const url = `${this.virtualOfficeServiceUrl}MeterReading/RegisterProof`;
    return this.httpClient.post<JsonResult<any>>(url, data).toPromise();
  }
  getPrivacyIsAcceptedByType(data: PrivacyDataFilterModel) {
    const url = `${this.virtualOfficeServiceUrl}LogPrivacyData/GetPrivacyIsAcceptedByType`;
    return this.httpClient.post<JsonResult<LogPrivacyDataFilterByTypeDto[]>>(url, data).toPromise();
  }

  sendMeterReadingEmail(data: MeterReadingEmailRecibos) {
    const url = `${this.virtualOfficeServiceUrl}MeterReading/EmailRecibos`;
    return this.httpClient.post<JsonResult<any>>(url, data).toPromise();
  }
  sendInsertPrivacyDataV2(data: ParameterPrivacidadDatosSAPDTO) {
    const url = `${this.virtualOfficeServiceUrl}LogPrivacyData/InsertPrivacyData-v2`;
    return this.httpClient.post<JsonResult<any>>(url, data).toPromise();
  }


  listNextMeterReadingSchedule(clientCode: string) {
    const url = `${this.environmentService.virtualOfficeServiceUrl}${this.MeterReadingController}/ListNextMeterReadingScheduleRecibos`;
    let params = new HttpParams();
    params = params.append("clientCode", clientCode);
    return this.httpClient.get<JsonResult<NextMeterReadingNextDateResponse[]>>(url, { params: params });
  }

  getMensajeAlerta() {
    let url = `${this.virtualOfficeServiceUrl}VirtualStore/MensajePagina/2`;
    return this.httpClient.get<JsonResult<HtmlPolicy>>(url).toPromise();
  }
}
